module.exports = __webpack_public_path__ + "img/mobile-project-2.1efd312e.jpg";